export var SSN_ALLOWABLE_DELIMITER_PATTERN = /[-. ]/;
export var SSN_HYPHEN_PATTERN = /^\d{3}-\d{2}-\d{4}$/;
export var SSN_MIXED_PATTERN = /^(\d{3})([-. ])(\d{2})([-. ])(\d{4})$/;
// Whitelist/blacklist is the more advanced and proper validation for SSN
export var SSN_WHITELIST_PATTERN = /^(?!000)[0-9]{3}[\\-](?!00)[0-9][0-9][\\-](?!0000)[0-9]{4}$/;
export var SSN_BLACKLIST_PATTERN = /^([0-9])\1\1-\1\1-\1\1\1\1$/; // This basically disallows repeating digits in the SSN
export var SSN_CAPTURING_GROUPS = /(\d{3})(\d{2})(\d{4})/;
//# sourceMappingURL=ssn.js.map